<template>
  <v-app-bar app flat dark dense :class="client === 'Hof' ? 'grey lighten-2' : 'blue lighten-5'" clipped-left>
    <!--Logo-->
    <slot name="brand">
      <AppLayoutNavbarLogo/>
    </slot>

    <v-spacer/>
    <slot name="apps" v-if="loggedIn">
      <AppLayoutNavbarApps/>
    </slot>

    <AppLayoutNavbarSettings v-if="$can('update applicationSettings') && loggedIn"/>

    <slot name="profile">
      <AppLayoutNavbarProfile/>
    </slot>
  </v-app-bar>
</template>

<script>
export default {
  name: "app-layout-navbar",
  computed: {
    loggedIn() {
      return this.$store.getters['user/loggedIn'];
    },
    client() {
      return process.env.VUE_APP_CLIENT;
    }
  }
}
</script>

<style scoped>

</style>
